module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/produto-promocao/produto-promocao.component.css
// module id = ./src/app/produto-promocao/produto-promocao.component.css
// module chunks = main